import React from 'react'
import './Marker.css'

export default function Marker(props) {
  const { color, name, id, zIndex, content } = props

  return (
    <div>
      <div
        className="pin bounce"
        style={{ background: color, cursor: 'pointer', zIndex: zIndex }}
        title={name}
      />

      {content && (
        <div
          style={{
            marginTop: -40,
            marginLeft: -30,
            borderRadius: 10,
            textAlign: 'center',
            backgroundColor: '#fc5e53',
            padding: 5,
            //zIndex: 9999999,
          }}
        >
          {content}
        </div>
      )}

      <div className="pulse" />
    </div>
  )
}
